import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { AutomotiveAftermarketProfileListFacade } from './automotive-aftermarket-profile-list.facade';

@Injectable({
  providedIn: 'root',
})
export class AutomotiveAftermarketProfileListGuard {
  constructor(private automotiveAftermarketProfileListFacade: AutomotiveAftermarketProfileListFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.automotiveAftermarketProfileListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.automotiveAftermarketProfileListFacade);
  }
}
